/**
 * Navigation Module
 *
 * Utilities for tab navigation, scroll behavior, and date helpers
 */

import moment from "moment";
import { get_config } from "@/utilities/";

/**
 * Check if a date is valid (not in the past)
 */
export function date_check(day) {
  return new Date(day.id) >= new Date();
}

/**
 * Format a date string for display in the booking engine
 * @param {string} date - Date in YYYY-MM-DD format
 * @returns {string} Formatted date (e.g., "lun 15 gen")
 */
export function formatDateDisplay(date) {
  if (!date) return "";
  return moment(date, "YYYY-MM-DD").format("ddd D MMM");
}

/**
 * Calculate minimum checkin date based on business rules
 * @returns {Date}
 */
export function calculateMinCheckinDate() {
  let min_date = moment();

  try {
    const minCheckin = get_config("guiSettings.minCheckin", undefined);
    if (minCheckin && moment(min_date).diff(minCheckin, "days") < 0) {
      min_date = moment(minCheckin);
    }

    const minDays = get_config("guiSettings.minDays", 0);
    min_date.add(minDays, "days");

    if (moment().hour() > 13) {
      min_date.add(1, "days");
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("calculateMinCheckinDate", e);
  }

  return min_date.toDate();
}

/**
 * Calculate maximum booking date (1 year from today)
 * @returns {Date}
 */
export function calculateMaxDate() {
  let today = new Date();
  let max_date = new Date(today);
  max_date.setDate(today.getDate() + 365);
  return max_date;
}
